import * as types from "./types";

const INITIAL_STATE = {
  list: [],
  meta: {},
  client: {},
  allClients: [],
};

const clientsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.CREATE_CLIENT_RESPONSE:
      return { ...state, client: action.payload };

    case types.GET_CLIENTS_RESPONSE:
      console.log("Updating Redux state with:", action.payload);
      return {
        ...state,
        list: action.payload.list,
        meta: action.payload.meta,
      };


    case types.GET_CLIENT_RESPONSE:
      return { ...state, client: action.payload };

    case types.GET_ALL_CLIENTS_RESPONSE:
      return { ...state, allClients: action.payload };

    case types.UPDATE_CLIENT_RESPONSE:
      return {
        ...state,
        list: state.list.map(client =>
          client.id === action.payload.id ? action.payload : client
        ),
        client: action.payload
      };

    default:
      return state;
  }
};

export default clientsReducer;
